import { render, staticRenderFns } from "./VendorSignIn.vue?vue&type=template&id=2f798882&scoped=true&"
import script from "./VendorSignIn.vue?vue&type=script&lang=js&"
export * from "./VendorSignIn.vue?vue&type=script&lang=js&"
import style0 from "./VendorSignIn.vue?vue&type=style&index=0&id=2f798882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f798882",
  null
  
)

export default component.exports